module.exports = __webpack_public_path__ + "img/bellicon.74adaa2e.svg";